import { render, staticRenderFns } from "./personal-page.vue?vue&type=template&id=8ba5006e&scoped=true&"
import script from "./personal-page.vue?vue&type=script&lang=js&"
export * from "./personal-page.vue?vue&type=script&lang=js&"
import style0 from "./personal-page.vue?vue&type=style&index=0&id=8ba5006e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ba5006e",
  null
  
)

export default component.exports